import { PostHogProvider as RealPostHogProvider } from 'posthog-js/react/slim';
import { useEffect, useState } from 'react';
import type { PostHog } from 'posthog-js';
import type { ReactElement } from 'react';

import { window } from './globals';

type Props = {
  children: ReactElement;
};

export const PostHogProvider = ({ children }: Props) => {
  const [client, setClient] = useState<PostHog | undefined>(undefined);

  useEffect(() => {
    // eslint-disable-next-line no-underscore-dangle
    window.__posthogReady?.then(setClient);
  }, []);

  if (!client) {
    return children;
  }
  return <RealPostHogProvider client={client}>{children}</RealPostHogProvider>;
};
